import { useState } from "react";
import { message } from "antd";

import { type BodyMeasurements } from "@fitness-app/data-models/entities/Measurement";

import { type BodyMeasurementFormModel } from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeMeasurements/BodyMeasurementForm/types";
import { useUpsertTraineeMeasurement } from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeMeasurements/useTraineeMeasurementsQueries";

export const useBodyMeasurementForm = (traineeId: string) => {
  const [showBodyMeasurementModal, toggleBodyMeasurementModal] = useState(false);
  const upsertMeasurement = useUpsertTraineeMeasurement(traineeId);

  const onAddNewBodyMeasurement = async (formModel: BodyMeasurementFormModel) => {
    try {
      await upsertMeasurement.mutateAsync({
        data: formModel.data as BodyMeasurements["data"],
        eventDate: formModel.date.format("YYYY-MM-DD"),
        id: formModel.id,
        previousMeasurement: formModel.previousMeasurement,
      });
      toggleBodyMeasurementModal(false);
    } catch {
      // Modal zostaje otwarty, żeby nie stracić wpisanych wartości.
      void message.error("Nie udało się zapisać pomiaru. Spróbuj ponownie.");
    }
  };

  return {
    onAddNewBodyMeasurement,
    showBodyMeasurementModal,
    addingBodyMeasurement: upsertMeasurement.isLoading,
    toggleBodyMeasurementModal,
  };
};
